export var valuesCourseStatus = ["NotStarted", "Started", "Finished"];
/*

*/ 
//# sourceMappingURL=CourseStatus.js.map